import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';

import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  FuseMediaWatcherService,
  FuseNavigationService,
  FuseVerticalNavigationComponent,
} from '@fleet/fuse';

import { FleetNavigationService } from '@fleet/navigation';

import { FuseNavigationItem } from '@fleet/fuse/lib/components';
import { GroupHierarchyItem } from '@fleet/model';
import { ProductConfigurationService } from '@fleet/product-configuration';

@Component({
  selector: 'fleet-flex-layout',
  templateUrl: './fleet-flex-layout.component.html',
  styleUrls: ['./fleet-flex-layout.component.scss'],
})
export class FleetFlexLayoutComponent implements OnInit {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  fleetProduct: string;
  isScreenSmall: boolean;
  navigation: FuseNavigationItem[];
  currentGroup: GroupHierarchyItem;
  logoSrc: string = 'assets/logos/fleet-driver-horiz.svg';
  envName: string;
  /**
   * Constructor
   */
  constructor(
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _fuseNavigationService: FuseNavigationService,
    private fleetNavigationService: FleetNavigationService,
    private changeDetectorRef: ChangeDetectorRef,
    private _productConfigurationService: ProductConfigurationService,
    @Inject('env') env: any
  ) {
    this.fleetProduct = env.fleetProduct;
    this.envName = env.envName;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to navigation data
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });

    this.fleetNavigationService.navigation$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (navigation: FuseNavigationItem[]) => {
          this.navigation = navigation;
          this.changeDetectorRef.markForCheck();
        },
      });

    this.fleetNavigationService.currentGroup$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (currentGroup: GroupHierarchyItem) => {
          this.currentGroup = currentGroup;
        },
      });

    this._productConfigurationService.config$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (config: any) => {
          if (config.horizontalLogo) {
            this.logoSrc = config.horizontalLogo;
            this.changeDetectorRef.markForCheck();
          }
        },
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation =
      this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
        name
      );

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }
}
